// @ts-nocheck

// import flat from 'array.prototype.flat';
import { routerMode } from 'config/env';

type AnyObj = { [key: string]: any };

export function deepClone(obj: AnyObj): AnyObj | null {
    if (obj === null) return null;
    let clone = Object.assign({}, obj);
    Object.keys(clone).forEach(key => (clone[key] = typeof obj[key] === 'object' ? deepClone(obj[key]) : obj[key]));
    if (Array.isArray(obj)) {
        clone.length = obj.length;
        // @ts-ignore
        return Array.from(clone);
    }
    return clone;
}

export function deepEqual(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) {
        return true;
    }
    if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
        return false;
    }
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
            return false;
        }
    }

    return true;
}

export function isArray(value: any) {
    if (typeof Array.isArray === 'function') {
        return Array.isArray(value);
    } else {
        return Object.prototype.toString.call(value) === '[object Array]';
    }
}

export function isObject(value: any) {
    return Object.prototype.toString.call(value) === '[object Object]';
}

export function isNumber(value: any) {
    return !isNaN(Number(value));
}

export function isFunction(value: any) {
    return typeof value == 'function';
}

export function isString(value: any) {
    return typeof value == 'string';
}

export function isNull(value: any) {
    return !value && value !== 0;
}

export function isEmpty(value: any) {
    if (isArray(value)) {
        return value.length === 0;
    }

    if (isObject(value)) {
        return Object.keys(value).length === 0;
    }

    return value === '' || value === undefined || value === null;
}

export function isBoolean(value: any) {
    return typeof value === 'boolean';
}

export function last(data: any) {
    if (isArray(data) || isString(data)) {
        return data[data.length - 1];
    }
}

export function cloneDeep(obj: any) {
    const d = isArray(obj) ? obj : {};

    if (isObject(obj)) {
        for (const key in obj) {
            if (obj[key]) {
                if (obj[key] && typeof obj[key] === 'object') {
                    d[key] = cloneDeep(obj[key]);
                } else {
                    d[key] = obj[key];
                }
            }
        }
    }

    return d;
}

// export function dataset(obj: any, key: string, value: any, isMerge?: boolean): any {
//     const isGet = value === undefined;
//     let d = obj;

//     const arr = flat(
//         key.split('.').map(e => {
//             if (e.includes('[')) {
//                 return e.split('[').map(e => e.replace(/"/g, ''));
//             } else {
//                 return e;
//             }
//         })
//     );

//     try {
//         for (let i = 0; i < arr.length; i++) {
//             const e: any = arr[i];
//             let n: any = null;

//             if (e.includes(']')) {
//                 const [k, v] = e.replace(']', '').split(':');

//                 if (v) {
//                     n = d.findIndex((x: any) => x[k] == v);
//                 } else {
//                     n = Number(k);
//                 }
//             } else {
//                 n = e;
//             }

//             if (i != arr.length - 1) {
//                 d = d[n];
//             } else {
//                 if (isGet) {
//                     return d[n];
//                 } else {
//                     if (isMerge) {
//                         Object.assign(d[n], value);
//                     } else {
//                         d[n] = value;
//                     }
//                 }
//             }
//         }

//         return obj;
//     } catch (e) {
//         console.error('格式错误', `${key}`);
//         return {};
//     }
// }

export function clone(obj: any) {
    return Object.create(Object.getPrototypeOf(obj), Object.getOwnPropertyDescriptors(obj));
}

export function deepMerge(a: any, b: any) {
    let k;
    for (k in b) {
        a[k] = a[k] && a[k].toString() === '[object Object]' ? deepMerge(a[k], b[k]) : (a[k] = b[k]);
    }
    return a;
}

export function contains(parent: any, node: any) {
    while (node && (node = node.parentNode)) if (node === parent) return true;
    return false;
}

export function getUrlParam(name: string) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    const r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
}

export function isPc() {
    const userAgentInfo = navigator.userAgent;
    const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

export function getBrowser() {
    const { clientHeight, clientWidth } = document.documentElement;

    // 浏览器信息
    const ua = navigator.userAgent.toLowerCase();

    // 浏览器类型
    let type = (ua.match(/firefox|chrome|safari|opera/g) || 'other')[0];

    if ((ua.match(/msie|trident/g) || [])[0]) {
        type = 'msie';
    }

    // 平台标签
    let tag = '';

    const isTocuh = 'ontouchstart' in window || ua.indexOf('touch') !== -1 || ua.indexOf('mobile') !== -1;
    if (isTocuh) {
        if (ua.indexOf('ipad') !== -1) {
            tag = 'pad';
        } else if (ua.indexOf('mobile') !== -1) {
            tag = 'mobile';
        } else if (ua.indexOf('android') !== -1) {
            tag = 'androidPad';
        } else {
            tag = 'pc';
        }
    } else {
        tag = 'pc';
    }

    // 浏览器内核
    let prefix = '';

    switch (type) {
        case 'chrome':
        case 'safari':
        case 'mobile':
            prefix = 'webkit';
            break;
        case 'msie':
            prefix = 'ms';
            break;
        case 'firefox':
            prefix = 'Moz';
            break;
        case 'opera':
            prefix = 'O';
            break;
        default:
            prefix = 'webkit';
            break;
    }

    // 操作平台
    const plat = ua.indexOf('android') > 0 ? 'android' : navigator.platform.toLowerCase();

    // 屏幕信息
    let screen = 'full';

    if (clientWidth < 768) {
        screen = 'xs';
    } else if (clientWidth < 992) {
        screen = 'sm';
    } else if (clientWidth < 1200) {
        screen = 'md';
    } else if (clientWidth < 1920) {
        screen = 'xl';
    } else {
        screen = 'full';
    }

    // 是否 ios
    const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

    // 浏览器版本
    const version = (ua.match(/[\s\S]+(?:rv|it|ra|ie)[\/: ]([\d.]+)/) || [])[1];

    // 是否 PC 端
    const isPC = tag === 'pc';

    // 是否移动端
    const isMobile = isPC ? false : true;

    // 是否移动端 + 屏幕宽过小
    const isMini = screen === 'xs' || isMobile;

    return {
        height: clientHeight,
        width: clientWidth,
        version,
        type,
        plat,
        tag,
        prefix,
        isMobile,
        isIOS,
        isPC,
        isMini,
        screen,
    };
}

export function href(path: string, newWindow?: boolean) {
    const { origin, pathname } = window.location;

    if (pathname == path) {
        return false;
    }

    let url = '';

    if (routerMode == 'history') {
        url = origin + import.meta.env.BASE_URL + path.substr(1);
    } else {
        url = origin + import.meta.env.BASE_URL + '#' + path;
    }

    if (newWindow) {
        window.open(url);
    } else {
        window.location.href = url;
    }
}

export function orderBy(list: Array<any>, key: any) {
    return list.sort((a, b) => a[key] - b[key]);
}

export function deepTree(list: Array<any>) {
    const newList: Array<any> = [];
    const map: any = {};

    list.forEach(e => (map[e.id] = e));

    list.forEach(e => {
        const parent = map[e.parentId];

        if (parent) {
            (parent.children || (parent.children = [])).push(e);
        } else {
            newList.push(e);
        }
    });

    const fn = (list: Array<any>) => {
        list.map(e => {
            if (e.children instanceof Array) {
                e.children = orderBy(e.children, 'orderNum');

                fn(e.children);
            }
        });
    };

    fn(newList);

    return orderBy(newList, 'orderNum');
}

export function revDeepTree(list: Array<any> = []) {
    const d: Array<any> = [];
    let id = 0;

    const deep = (list: Array<any>, parentId: any) => {
        list.forEach(e => {
            if (!e.id) {
                e.id = id++;
            }

            e.parentId = parentId;

            d.push(e);

            if (e.children && isArray(e.children)) {
                deep(e.children, e.id);
            }
        });
    };

    deep(list || [], null);

    return d;
}

/*
 * 六合彩多选中一算法Permutations
 * arr:需要排列组合的数组,
 * n:需要排列组合的个数,
 * res 空数组
 * out 最终结果数组
 */

export function Permutations(arr: any, n: number, res = [], out: string[][]) {
    if (n === 0) {
        out.push(res);
        return out;
    }
    if (arr.length === n) {
        out.push(res.concat(arr));
        return out;
    }

    for (let i = 0; i <= arr.length - n; i++) {
        let temp = res.slice(0);
        // @ts-ignore
        temp.push(arr[i]);
        Permutations(arr.slice(i + 1), n - 1, temp, out);
    }
}

export function basename(path: string) {
    let index = path.lastIndexOf('/');
    index = index > -1 ? index : path.lastIndexOf('\\');
    if (index < 0) {
        return path;
    }
    return path.substring(index + 1);
}

export function sum(arr: any[]) {
    let s = 0;
    for (let i = arr.length - 1; i >= 0; i--) {
        s += parseInt(arr[i]);
    }
    return s;
}

export const keyCodes = Object.freeze({
    enter: 13,
    tab: 9,
    delete: 46,
    esc: 27,
    space: 32,
    up: 38,
    down: 40,
    left: 37,
    right: 39,
    end: 35,
    home: 36,
    del: 46,
    backspace: 8,
    insert: 45,
    pageup: 33,
    pagedown: 34,
    shift: 16,
});

// 数组对象深度对比
export function deepCompare(x: any, y: any) {
    let i, l, leftChain: any, rightChain: any;
    // @ts-ignore
    let that = this;

    function compare2Objects(x: any, y: any) {
        let p;

        // 记住 NaN === NaN 返回 false
        // 并且 isNaN(undefined) 返回 true
        if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
            return true;
        }

        // 比较原语和函数。
        // 检查两个参数是否链接到同一个对象。
        // 在我们比较原型的步骤中特别有用
        if (x === y) {
            return true;
        }

        // 在构造函数中创建函数的情况下有效。
        // 比较日期是一种常见的情况。 另一个内置插件？
        // 我们甚至可以处理跨 iframe 传递的函数
        if (
            (typeof x === 'function' && typeof y === 'function') ||
            (x instanceof Date && y instanceof Date) ||
            (x instanceof RegExp && y instanceof RegExp) ||
            (x instanceof String && y instanceof String) ||
            (x instanceof Number && y instanceof Number)
        ) {
            return x.toString() === y.toString();
        }

        // 最后尽可能地检查原型
        if (!(x instanceof Object && y instanceof Object)) {
            return false;
        }

        if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
            return false;
        }

        if (x.constructor !== y.constructor) {
            return false;
        }

        if (x.prototype !== y.prototype) {
            return false;
        }

        // 检查不定式链接循环
        if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
            return false;
        }

        // 快速检查一个对象是另一个对象的子集。
        // todo: 缓存 arguments[0] 的结构以提高性能
        for (p in y) {
            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                return false;
            } else if (typeof y[p] !== typeof x[p]) {
                return false;
            }
        }

        for (p in x) {
            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                return false;
            } else if (typeof y[p] !== typeof x[p]) {
                return false;
            }

            switch (typeof x[p]) {
                case 'object':
                case 'function':
                    leftChain.push(x);
                    rightChain.push(y);

                    if (!compare2Objects(x[p], y[p])) {
                        return false;
                    }

                    leftChain.pop();
                    rightChain.pop();
                    break;

                default:
                    if (x[p] !== y[p] && p !== 'nowTime') {
                        return false;
                    }
                    break;
            }
        }

        return true;
    }

    if (arguments.length < 1) {
        return true;
    }

    for (i = 1, l = arguments.length; i < l; i++) {
        leftChain = []; //Todo: this can be cached
        rightChain = [];

        if (!compare2Objects(arguments[0], arguments[i])) {
            return false;
        }
    }

    return true;
}

// 数字 1转一
export function numberChinese(number: number) {
    const strNumber = number.toString();
    let numberCh = '';
    switch (strNumber) {
        case '0':
            numberCh += '零';
            break;
        case '1':
            numberCh += '一';
            break;
        case '2':
            numberCh += '二';
            break;
        case '3':
            numberCh += '三';
            break;
        case '4':
            numberCh += '四';
            break;
        case '5':
            numberCh += '五';
            break;
        case '6':
            numberCh += '六';
            break;
        case '7':
            numberCh += '七';
            break;
        case '8':
            numberCh += '八';
            break;
        case '9':
            numberCh += '九';
            break;
        case '10':
            numberCh += '十';
            break;
        case '11':
            numberCh += '十一';
            break;
        case '12':
            numberCh += '十二';
            break;
        case '13':
            numberCh += '十三';
            break;
        case '14':
            numberCh += '十四';
            break;
        case '15':
            numberCh += '十五';
            break;
        default:
            numberCh += '*';
    }

    return numberCh;
}

// 六合彩连码排列组合 生肖对碰 尾数对碰
export function permutations2(arr: any, n: any = 0) {
    let list = [[]];

    for (let i = 0; i < arr.length; i++) {
        let t_arr = [];
        for (let j = 0; j < list.length; j++) {
            for (let k = 0; k < arr[i].length; k++) {
                // @ts-ignore
                t_arr.push(list[j].concat(arr[i][k].toString().padStart(2, '0')));
            }
        }
        list = t_arr;
    }

    for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (item[0] === item[1]) {
            list.splice(i, 1);
            i--;
        }
    }

    return list;
}

export function permutations3(arr: any) {
    const getResult = (arrA: any, arrB: any) => {
        if (!Array.isArray(arrA) || !Array.isArray(arrB)) {
            return;
        }
        if (arrA.length === 0) {
            return arrB;
        }
        if (arrB.length === 0) {
            return arrA;
        }
        let result = [];
        for (let i = 0; i < arrA.length; i++) {
            for (let j = 0; j < arrB.length; j++) {
                // @ts-ignore
                result.push(String(arrA[i]) + String(arrB[j]));
            }
        }
        return result;
    };

    const findAll = (arr: any) => {
        return arr.reduce((total: any, current: any) => {
            return getResult(total, current);
        }, []);
    };
    return findAll(arr);
}

//时分秒换算
export function date_format_card(micro_second: any) {
    if (Number(micro_second) > 0) {
        // 总秒数
        let second = Math.floor(micro_second / 1000);
        // 天数
        let day = Math.floor(second / 3600 / 24);
        // 小时
        let hr = Math.floor((second / 3600) % 24);
        // 分钟
        let min = Math.floor((second / 60) % 60)
            .toString()
            .padStart(2, '0');
        // 秒
        let sec = Math.floor(second % 60)
            .toString()
            .padStart(2, '0');
        return (day * 24 + hr).toString().padStart(2, '0') + ':' + min + ':' + sec;
        // return day + " " + hr + ":" + min + ":" + sec
    } else {
        return '00' + ':' + '00' + ':' + '00';
    }
}

// 时间格式化
export function formatTimeFromSeconds(endSecond: number): string {
    const hours = Math.floor(endSecond / 3600);
    const minutes = Math.floor((endSecond % 3600) / 60);
    const seconds = endSecond % 60;

    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

/**
 * pc蛋蛋获取波色
 * 1,4,7,10,16,19,22,25 为绿波
 * 2,5,8,11,17,20,23,26 为蓝波
 * 3,6,9,12,15,18,21,24 为红波
 * 0,13,14,27 (所有的波色都输)视为全部不中奖！
 * @param num
 */
export function getTextColor(num: number) {
    if ([1, 4, 7, 10, 16, 19, 22, 25].includes(num)) {
        return 'green';
    } else if ([2, 5, 8, 11, 17, 20, 23, 26].includes(num)) {
        return 'blue';
    } else if ([3, 6, 9, 12, 15, 18, 21, 24].includes(num)) {
        return 'red';
    } else {
        return 'gray';
    }
}

export function getSixTextColor(num: number) {
    if ([1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46].includes(num)) {
        return 'red';
    } else if ([3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48].includes(num)) {
        return 'blue';
    } else if ([5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49].includes(num)) {
        return 'green';
    } else {
        return 'gray';
    }
}

// 判断H5跳转到哪个页面 根据分类code和gameCode
/**
 * switch (categoryCode) {
 *                 case 1:
 *                     // 时时彩
 *                     router.push(`/lottery-wap/ssc?gameCode=${gameCode}&categoryCode=${categoryCode}`);
 *                     break;
 *                 case 2:
 *                     // 11选5
 *                     router.push(`/lottery-wap/syxw?gameCode=${gameCode}&categoryCode=${categoryCode}`);
 *                     break;
 *                 case 4:
 *                     // 六合彩
 *                     router.push(`/lottery-wap/six?gameCode=${gameCode}&categoryCode=${categoryCode}`);
 *                     break;
 *                 case 5:
 *                     // 快3
 *                     router.push(`/lottery-wap/k3?gameCode=${gameCode}&categoryCode=${categoryCode}`);
 *                     break;
 *                 case 6:
 *                     // PK十
 *                     router.push(`/lottery-wap/pk10?gameCode=${gameCode}&categoryCode=${categoryCode}`);
 *                     break;
 *                 case 7:
 *                     // PC蛋蛋
 *                     router.push(`/lottery-wap/pcdd?gameCode=${gameCode}&categoryCode=${categoryCode}`);
 *                     break;
 *                 case 8:
 *                     // 快乐8
 *                     router.push(`/lottery-wap/kl8?gameCode=${gameCode}&categoryCode=${categoryCode}`);
 *                     break;
 *                 case 9:
 *                     // 分分彩信
 *                     router.push(`/lottery-wap/ssc?gameCode=${gameCode}&categoryCode=${categoryCode}`);
 *                     break;
 *                 case 10:
 *                     // 快乐十分
 *                     router.push(`/lottery-wap/klsf?gameCode=${gameCode}&categoryCode=${categoryCode}`);
 *                     break;
 *                 case 11:
 *                     // 快乐十分
 *                     router.push(`/lottery-wap/d3?gameCode=${gameCode}&categoryCode=${categoryCode}`);
 *                     break;
 *                 default:
 *                     // 时时彩
 *                     router.push(`/lottery-wap/ssc?gameCode=${gameCode}&categoryCode=${categoryCode}`);
 *                     break;
 *             }
 */
export function getCategoryCode(categoryCode: number, gameCode: number) {
    let url = '';
    switch (categoryCode) {
        case 1:
            // 时时彩
            url = `/lottery-wap/ssc?gameCode=${gameCode}&categoryCode=${categoryCode}`;
            break;
        case 2:
            // 11选5
            url = `/lottery-wap/syxw?gameCode=${gameCode}&categoryCode=${categoryCode}`;
            break;
        case 4:
            // 六合彩
            url = `/lottery-wap/six?gameCode=${gameCode}&categoryCode=${categoryCode}`;
            break;
        case 5:
            // 快3
            url = `/lottery-wap/k3?gameCode=${gameCode}&categoryCode=${categoryCode}`;
            break;
        case 6:
            // PK十
            url = `/lottery-wap/pk10?gameCode=${gameCode}&categoryCode=${categoryCode}`;
            break;
        case 7:
            // PC蛋蛋
            url = `/lottery-wap/pcdd?gameCode=${gameCode}&categoryCode=${categoryCode}`;
            break;
        case 8:
            // 快乐8
            url = `/lottery-wap/kl8?gameCode=${gameCode}&categoryCode=${categoryCode}`;
            break;
        case 9:
            // 分分彩信
            url = `/lottery-wap/ssc?gameCode=${gameCode}&categoryCode=${categoryCode}`;
            break;
        case 10:
            // 快乐十分
            url = `/lottery-wap/klsf?gameCode=${gameCode}&categoryCode=${categoryCode}`;
            break;
        case 11:
            // 快乐十分
            url = `/lottery-wap/d3?gameCode=${gameCode}&categoryCode=${categoryCode}`;
            break;
        case 21:
            // win Go
            url = `/gameMobileWin?gameCode=${gameCode}&categoryId=${categoryCode}`;
            break;
        case 22:
            // k3
            url = `/gameMobileColorLand?gameCode=${gameCode}&categoryId=${categoryCode}`;
            break;
        case 23:
            // 5D
            url = `/gameMobile5d?gameCode=${gameCode}&categoryId=${categoryCode}`;
            break;
        case 24:
            // Trx Win
            url = `/gameMobileTRXWin?gameCode=${gameCode}&categoryId=${categoryCode}`;
            break;
        default:
            // 时时彩
            url = `/lottery-wap/ssc?gameCode=${gameCode}&categoryCode=${categoryCode}`;
            break;
    }
    return url;
}
